// Publieke Google-configuratie voor de Google Slides-import (Sprekers). Eén
// centraal Google Cloud-project voor Zoea. Alle drie de waarden zijn publiek
// (client-ID, browser-API-key met referrer-beperking, projectnummer): er is
// geen client-secret en er worden geen tokens bewaard.
//
// De koppeling staat UIT tenzij REACT_APP_GOOGLE_SLIDES_IMPORT_ENABLED=true en
// alle drie de waarden gezet zijn. Zelfs dan toont de UI de optie alleen aan
// gebruikers die de server expliciet heeft toegelaten (pilot-allowlist, zie
// useGoogleSlidesAccess); de backend (GOOGLE_SLIDES_IMPORT_ENABLED +
// GOOGLE_SLIDES_PILOT_USER_IDS) blijft de bron van waarheid.

/** Uitsluitend per-bestand toegang tot wat de gebruiker zelf kiest. */
export const GOOGLE_DRIVE_FILE_SCOPE = 'https://www.googleapis.com/auth/drive.file';
export const GOOGLE_SLIDES_MIME_TYPE = 'application/vnd.google-apps.presentation';

export interface GoogleConfig {
  clientId: string;
  apiKey: string;
  projectNumber: string;
}

export function getGoogleConfig(): GoogleConfig | null {
  if (process.env.REACT_APP_GOOGLE_SLIDES_IMPORT_ENABLED !== 'true') return null;
  const clientId = (process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID || '').trim();
  const apiKey = (process.env.REACT_APP_GOOGLE_PICKER_API_KEY || '').trim();
  const projectNumber = (process.env.REACT_APP_GOOGLE_CLOUD_PROJECT_NUMBER || '').trim();
  if (!clientId || !apiKey || !projectNumber) return null;
  return { clientId, apiKey, projectNumber };
}

export function isGoogleSlidesConfigured(): boolean {
  return getGoogleConfig() !== null;
}
